// extracted by mini-css-extract-plugin
export var cardContainer = "_o2-0";
export var cardHeader = "_o2-2";
export var collapsedState = "_o2-3";
export var dragHandle = "_o2-5";
export var dragHandleIcon = "_o2-6";
export var dragging = "_o2-1";
export var titleArea = "_o2-4";